// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Pagination, Autoplay, A11y } from 'swiper/modules';

import 'swiper/scss';
import 'swiper/scss/a11y'
import 'swiper/scss/pagination'

const SwiperInit = () => {
  const sliderSelector = '.swiper'
  const defaultOptions = {
    modules: [Pagination, Autoplay, A11y]
  };

  const swiperNodes = document.querySelectorAll(sliderSelector);

  [].forEach.call(swiperNodes, ( swiperInstance ) => {

    // console.log(swiperInstance)

    const data = swiperInstance.getAttribute('data-swiper-settings') || {};

    if (data) {
      const dataOptions = JSON.parse(data);

      swiperInstance.options = Object.assign({}, defaultOptions, dataOptions);
      const swiper = new Swiper(swiperInstance, swiperInstance.options);
    }
  });
}

export default SwiperInit;
